import { useState } from 'react';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import PratusSelect, {
  OptionType,
} from 'components/DesignSystems/New/PratusSelect';
import StylishNewInput from 'components/DesignSystems/New/StylishNewInput';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';

export type WorkAssignmentResource = {
  resourceName: string;
  required: string;
  have: string;
  need: string;
  handleRemove?: (index: number) => void;
};
export const WorkAssignmentResources = ({
  resourceOptions,
  resourceList,
  handleSave,
  handleRemove,
  readOnly = false,
}: {
  resourceOptions: { label: string; value: string }[];
  resourceList: any[] | null | undefined;
  handleSave: (resource: any) => void;
  handleRemove?: (index: number) => void;
  readOnly?: boolean;
}) => {
  const [resourceText, setResourceText] = useState('');
  const [showResourceAdd, setShowResourceAdd] = useState(false);
  const [required, setRequired] = useState('');
  const [have, setHave] = useState('');
  const [need, setNeed] = useState('');
  const [tempResources, setTempResources] = useState<any[]>([]);
  const [savedResource, setSavedResource] = useState<
    WorkAssignmentResource[] | null
  >(resourceList ?? null);

  const clearResourceForm = () => {
    setShowResourceAdd(false);
    setResourceText('');
    setRequired('');
    setHave('');
    setNeed('');
  };

  const removeItem = (index: number) => {
    if (savedResource) {
      const updatedResources = savedResource.filter((_, i) => i !== index);
      setSavedResource(updatedResources);
      if (handleRemove) {
        handleRemove(index);
      }
    }
  };

  const resOptions = [
    { label: '+ Add Resource', value: 'none' },
    ...tempResources.map((res) => ({
      label: res.resourceName,
      value: res.resourceName,
    })),
    ...resourceOptions,
  ];

  return (
    <>
      {!readOnly && (
        <div className="mt-2">
          <PratusSelect
            label="Add Resource"
            options={resOptions}
            onChange={(newValue) => {
              setShowResourceAdd(true);
              if ((newValue as OptionType).value !== 'none') {
                setResourceText((newValue as OptionType).label as string);
              }
            }}
          />
        </div>
      )}
      {showResourceAdd && !readOnly && (
        <>
          <div className="d-flex">
            <div className="col-6">
              <StylishNewInput
                value={resourceText}
                onChange={(e) => setResourceText(e.target.value as string)}
              />
            </div>
            <div className="col-2">
              <StylishNewInput
                placeholder="Required"
                value={required}
                onChange={(e) => setRequired(e.target.value)}
              />
            </div>
            <div className="col-2">
              <StylishNewInput
                placeholder="Have"
                value={have}
                onChange={(e) => setHave(e.target.value)}
              />
            </div>
            <div className="col-2">
              <StylishNewInput
                placeholder="Need"
                value={need}
                onChange={(e) => setNeed(e.target.value)}
              />
            </div>
          </div>
          <StylishNewButton
            className="me-1 mt-1"
            onClick={() => {
              const newResource = {
                resourceName: resourceText,
                required,
                have,
                need,
              };
              const toAdd = savedResource
                ? [...savedResource, newResource]
                : [newResource];
              setSavedResource(toAdd);
              handleSave(newResource);
              clearResourceForm();
              if (
                !resOptions.some(
                  (option) => option.label === newResource.resourceName
                )
              ) {
                setTempResources((prev) => [...prev, newResource]);
              }
            }}
          >
            Save
          </StylishNewButton>
          <StylishNewButton
            onClick={clearResourceForm}
            className="button--secondary mt-1"
          >
            Cancel
          </StylishNewButton>
        </>
      )}
      {savedResource && savedResource.length > 0 && (
        <div className="d-flex border-bottom mt-2">
          <span className="col-5">Name</span>
          <span className="col-2">Required</span>
          <span className="col-2">Have</span>
          <span className="col-2">Need</span>
        </div>
      )}
      {savedResource?.map((res, index) => (
        <div key={index} className="d-flex mt-2">
          <span className="col-5">{res?.resourceName}</span>
          <span className="col-2">{res?.required}</span>
          <span className="col-2">{res?.have}</span>
          <span className="col-2">{res?.need}</span>
          {!readOnly && (
            <span className="col-1">
              <StylishNewButton
                className="button--link"
                onClick={() => removeItem(index)}
              >
                <SharedIcon iconName="close" color="light" />
              </StylishNewButton>
            </span>
          )}
        </div>
      ))}
    </>
  );
};
